import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return <div className={cn('animate-pulse rounded-md bg-[#CAC7C7]', className)} />;
}

export function CardSkeleton() {
  return (
    <div className="bg-white rounded-lg p-6 shadow-md space-y-4">
      <Skeleton className="h-4 w-20" />
      <Skeleton className="h-6 w-full" />
      <Skeleton className="h-6 w-3/4" />
      <div className="space-y-2">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
      </div>
      <div className="flex items-center gap-2 pt-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-4 rounded-full" />
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  );
}

export function FeedSkeleton() {
  return (
    <div className="space-y-4">
      {Array.from({ length: 3 }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}

export function ContentSkeleton() {
  return (
    <div className="max-w-3xl mx-auto">
      {/* Header skeleton */}
      <div className="px-4 py-3 border-b border-[#CAC7C7]">
        <div className="flex items-center justify-between">
          <Skeleton className="h-10 w-10 rounded-full" />
          <div className="flex gap-2">
            <Skeleton className="h-10 w-10 rounded-full" />
            <Skeleton className="h-10 w-10 rounded-full" />
          </div>
        </div>
        <Skeleton className="h-5 w-24 mt-4" />
        <Skeleton className="h-8 w-full mt-3" />
        <Skeleton className="h-8 w-3/4 mt-2" />
        <div className="flex gap-3 mt-3">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>

      {/* Body skeleton */}
      <div className="px-4 py-6 space-y-4">
        <div className="p-4 bg-[#F4F2F2] rounded-lg">
          <Skeleton className="h-4 w-16 mb-2" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6 mt-2" />
        </div>
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/5" />
        <Skeleton className="h-4 w-full mt-4" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    </div>
  );
}

export function SavedItemSkeleton() {
  return (
    <div className="flex gap-4 p-4 bg-white rounded-lg shadow-sm">
      <Skeleton className="h-20 w-20 rounded-lg flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <div className="flex gap-2 pt-1">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
    </div>
  );
}

export function SavedListSkeleton() {
  return (
    <div className="space-y-3">
      {Array.from({ length: 5 }).map((_, i) => (
        <SavedItemSkeleton key={i} />
      ))}
    </div>
  );
}
